export default __webpack_public_path__ + "static/media/npc_03.88a643c6.png";